module.exports = __webpack_public_path__ + "media/img/welurowa@3x-0a3ec7b8.svg";